export default __webpack_public_path__ + "static/media/Home_BG-01.8ae2b4ba.png";